import React from "react";
import Image from "next/image";
import IMAGES from "@/public/assets/img";

const ExportCta = ({ data, onBookClick, onCheckClick }) => {
  if (!data) return null;

  return (
    <section className="relative py-sp-100 sm:py-20 text-center overflow-hidden">
      <Image
        priority={true}
        src={IMAGES.exportInterest.lowerBG}
        width={1366}
        height={550}
        className="absolute inset-0 max-w-none w-full h-full object-cover"
        alt="Banner Desktop"
      />
      <div className="container px-3 relative z-10 flex flex-col items-center max-w-[850px]">
        <h2 
          className="text-white text-heading sm:text-2xl font-medium mb-4"
          dangerouslySetInnerHTML={{ __html: data.heading }}
        />
        <p className="text-white text-base sm:text-sm mb-5">
          {data.subHeading}
        </p>

        <div className="flex sm:flex-col items-stretch sm:items-center justify-center gap-4 mb-8 w-full">
          {data.bookBtnText &&
          <button
            onClick={onBookClick}
            className="bg-[#E3A003] text-black text-base font-semibold py-3.5 px-6 sm:px-2 rounded-xl flex items-center justify-center gap-1 transition-all duration-300 shadow-lg"
          >
            {data.bookBtnText}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M7 3V1H9V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V9H20V5H17V7H15V5H9V7H7V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7ZM17 12C14.7909 12 13 13.7909 13 16C13 18.2091 14.7909 20 17 20C19.2091 20 21 18.2091 21 16C21 13.7909 19.2091 12 17 12ZM11 16C11 12.6863 13.6863 10 17 10C20.3137 10 23 12.6863 23 16C23 19.3137 20.3137 22 17 22C13.6863 22 11 19.3137 11 16ZM16 13V16.4142L18.2929 18.7071L19.7071 17.2929L18 15.5858V13H16Z"></path></svg>
          </button>}
          {data.checkBtnText &&
          <button
              className="flex gap-2 border border-[#6A829F] bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C] text-white px-6 sm:px-4 py-[13px] rounded-xl text-base font-semibold whitespace-nowrap"
              onClick={onCheckClick}
            >
             {data.checkBtnText}
              <svg
                xmlns="https://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="brand"
                width="24"
                height="24"
                className="transition-transform duration-200 transform group-hover:translate-x-[20px] fill-current text-white"
              >
                <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
              </svg>{" "}
            </button>}
        </div>
        {data.trustText &&
        <p className="text-white text-sm">
          {data.trustText}
        </p>}
      </div>
    </section>
  );
};

export default ExportCta;
